export const TABLE_SIZE_STORAGE_KEY = '__$table-custom-size'
